import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'hash',
    base: '/',
    routes: [
        {
            path: '/',
            name: 'Chat',
            component: r => require.ensure([], () => r(require('@/pages/chat/main.vue')), 'Chat')
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js